import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import PasswordInput from '@/components/form/input/password-input'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'

type PasswordConfirmationFieldsProps<TFormValues extends FieldValues> = {
  form: UseFormReturn<TFormValues>
  passwordName: Path<TFormValues>
  confirmationName: Path<TFormValues>
  passwordLabel?: string
  passwordPlaceholder?: string
  confirmationLabel?: string
  confirmationPlaceholder?: string
}

export function PasswordConfirmationFields<TFormValues extends FieldValues>({
  form,
  passwordName,
  confirmationName,
  passwordLabel = 'Senha',
  passwordPlaceholder = 'Digite a senha',
  confirmationLabel = 'Confirmar senha',
  confirmationPlaceholder = 'Digite novamente a senha'
}: PasswordConfirmationFieldsProps<TFormValues>) {
  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name={passwordName}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{passwordLabel}</FormLabel>
            <FormControl>
              <PasswordInput field={field} placeholder={passwordPlaceholder} autoComplete="new-password" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name={confirmationName}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{confirmationLabel}</FormLabel>
            <FormControl>
              <PasswordInput
                field={field}
                placeholder={confirmationPlaceholder}
                autoComplete="new-password"
                onPaste={event => event.preventDefault()}
                onDrop={event => event.preventDefault()}
                onCut={event => event.preventDefault()}
                {...field}
              />
            </FormControl>
            <FormDescription>Digite a confirmação manualmente. Colar foi desabilitado neste campo.</FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  )
}

export default PasswordConfirmationFields
